/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} MembersInputs */

const en_members = /** @type {(inputs: MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Members`)
};

const es_members = /** @type {(inputs: MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miembros`)
};

const fr_members = /** @type {(inputs: MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membres`)
};

const de_members = /** @type {(inputs: MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitglieder`)
};

const id_members = /** @type {(inputs: MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anggota`)
};

/** @type {(inputs: MembersInputs) => LocalizedString} */
const ja_members = en_members;

/** @type {(inputs: MembersInputs) => LocalizedString} */
const zh_members = en_members;

/** @type {(inputs: MembersInputs) => LocalizedString} */
const ar_members = en_members;

/** @type {(inputs: MembersInputs) => LocalizedString} */
const it_members = en_members;

/** @type {(inputs: MembersInputs) => LocalizedString} */
const ru_members = en_members;

/** @type {(inputs: MembersInputs) => LocalizedString} */
const pt_members = en_members;

/** @type {(inputs: MembersInputs) => LocalizedString} */
const ko_members = en_members;

/**
* | output |
* | --- |
* | "Members" |
*
* @param {MembersInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const members = /** @type {((inputs?: MembersInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<MembersInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_members(inputs)
	if (locale === "es") return es_members(inputs)
	if (locale === "fr") return fr_members(inputs)
	if (locale === "de") return de_members(inputs)
	if (locale === "ja") return ja_members(inputs)
	if (locale === "zh") return zh_members(inputs)
	if (locale === "ar") return ar_members(inputs)
	if (locale === "id") return id_members(inputs)
	if (locale === "it") return it_members(inputs)
	if (locale === "ru") return ru_members(inputs)
	if (locale === "pt") return pt_members(inputs)
	return ko_members(inputs)
});